var SpriteSymbol = require("../../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "fav",
  "use": "fav-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"fav\"><title></title><g id=\"fav_Fill\"><path d=\"M16,29.41,4.34,17.77a8.13,8.13,0,0,1,0-11.41,8,8,0,0,1,11.33,0L16,6.7l.33-.34a8,8,0,0,1,11.33,0,8.14,8.14,0,0,1,0,11.41ZM10,6A5.94,5.94,0,0,0,5.75,7.77a6.13,6.13,0,0,0,0,8.59L16,26.59,26.25,16.36a6.13,6.13,0,0,0,0-8.59,6,6,0,0,0-8.49,0L16,9.51,14.25,7.78A6,6,0,0,0,10,6Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id